import type { ReactNode } from 'react';
import { BaseStyles } from '@primer/react';
import { ThemeProvider } from '@primer/react/next';

/** Primer controls use the CSS tokens loaded by main.tsx, without legacy JS color tables. */
export function AppTheme({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider colorMode="night" nightScheme="dark">
      <BaseStyles>{children}</BaseStyles>
    </ThemeProvider>
  );
}
